import { render } from "./AppHeader.vue?vue&type=template&id=274f080f&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=274f080f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b5029c4e2822f65c6b0ae42e2fbfada5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274f080f"]])

export default __exports__